(() => {
  document.querySelectorAll('[data-mv-countdown]').forEach((root) => {
    const raw = root.dataset.mvCountdown;
    const end = /^\d+$/.test(raw) ? Number(raw) * 1000 : Date.parse(raw);
    if (Number.isNaN(end)) return;

    const cells = {
      d: root.querySelector('[data-unit="d"]'),
      h: root.querySelector('[data-unit="h"]'),
      m: root.querySelector('[data-unit="m"]'),
      s: root.querySelector('[data-unit="s"]'),
    };
    const doneEl = root.querySelector('[data-mv-countdown-done]');
    const unitsEl = root.querySelector('[data-mv-countdown-units]');

    const pad = (n) => String(n).padStart(2, '0');
    let timer = null;
    const render = () => {
      const diff = Math.max(0, end - Date.now());
      if (cells.d) cells.d.textContent = pad(Math.floor(diff / 86400000));
      if (cells.h) cells.h.textContent = pad(Math.floor((diff % 86400000) / 3600000));
      if (cells.m) cells.m.textContent = pad(Math.floor((diff % 3600000) / 60000));
      if (cells.s) cells.s.textContent = pad(Math.floor((diff % 60000) / 1000));

      if (diff === 0) {
        if (unitsEl) unitsEl.classList.add('mv-cd-units--done');
        if (doneEl) doneEl.classList.add('mv-cd-done--show');
        if (timer) clearInterval(timer);
      }
    };

    render();
    timer = setInterval(render, 1000);
  });
})();
